// src/routes/Routers.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../components/Home";
import ServicesPage from "../components/ServicesPage";
import ContactUs from "../components/ContactUs";
import ServiceItem from "../components/sub-comps/ServiceItem";
import ReviewsWidget from "../components/sub-comps/MoreReviews";



const Routers = () => {
    return (
        <div>
            <Routes>
                {/* Public route for Signin */}
                <Route path="/" element={<Home />} />
                <Route path="/services/:id" element={<ServiceItem />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/more-reviews" element={<ReviewsWidget/>} />
            </Routes>
        </div>
    );
};

export default Routers;
